import React from 'react';
import { createSvgIcon } from '../IconBase';

export default createSvgIcon(
  <path d="M2.2,8.5h4.3V22H2.2V8.5z M4.4,2C2.9,2,1.9,3,1.9,4.3c0,1.3,0.9,2.3,2.4,2.3h0c1.5,0,2.4-1,2.4-2.3C6.8,3,5.8,2,4.4,2z M17.1,8.2c-2.3,0-3.3,1.3-3.9,2.2V8.5H8.9c0.1,1.3,0,13.5,0,13.5h4.3v-7.5c0-0.4,0-0.8,0.1-1.1c0.3-0.8,1-1.6,2.2-1.6 c1.6,0,2.2,1.2,2.2,3V22h4.3v-7.7C22.1,10.1,19.9,8.2,17.1,8.2z" />,
  'LinkedInSimple',
);
